// extracted by mini-css-extract-plugin
export default {"car-mobile":"Car_car-mobile__omI4V","head":"Car_head__21urG","repair":"Car_repair__aAs9r"};